package com.hyperether.goodjob.scenes.jobs

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.lifecycle.viewModelScope
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.goodjob.isWebMobileView
import com.hyperether.goodjob.repository.Repository
import com.hyperether.goodjob.repository.remote.model.Resource
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.unexpected_error
import com.hyperether.goodjob.resources.unknown_error
import com.hyperether.goodjob.scenes.JobsViewModel
import com.hyperether.resources.stringResourcePlain
import kotlinx.coroutines.launch
import org.lighthousegames.logging.logging

class JobListViewModel(repository: Repository) : JobsViewModel(repository) {
    val log = logging("JobViewModel")

    val showEditPopUp: MutableState<Boolean> = mutableStateOf(false)
    val isInEditMode: MutableState<Boolean> = mutableStateOf(false)
    val showPopUpSuccess: MutableState<Boolean> = mutableStateOf(false)
    val showPopUpError: MutableState<Boolean> = mutableStateOf(false)
    val showLoader: MutableState<Boolean> = mutableStateOf(false)
    val errorText: MutableState<String> = mutableStateOf("")
    val showAreYouSurePopUpDeleteJob: MutableState<Boolean> = mutableStateOf(false)

    init {
        tag = "JobListViewModel"
        if (getPlatformChecker().isMobile())
            init()
    }

    fun init() {
        // initViewModel will fetch data on web: team, sites, jobs
        resetFilter()
        initViewModel()
        if (getPlatformChecker().isMobile()) {
            loadRemoteData()
        }
    }

    fun deleteSelectedJobs(
        onAllDeleted: () -> Unit,
        onError: (String) -> Unit
    ) {
        if (selectedJobs.isNotEmpty()) {
            viewModelScope.launch {
                try {
                    selectedJobs.forEachIndexed { index, job ->
                        val isLastJob = index == selectedJobs.size - 1
                        job.id?.let { id ->
                            val result = repository.deleteJobById(id)
                            if (result is Resource.Success && isLastJob) {
                                if (isWebMobileView() || !getPlatformChecker().isMobile()) {
                                    init()
                                }
                                onAllDeleted()
                            } else if (result is Resource.Error) {
                                errorText.value =
                                    result.text ?: stringResourcePlain(Res.string.unknown_error)
                                onError(id)
                                return@launch
                            }
                        }
                    }
                    selectedJobs.clear()
                } catch (e: Exception) {
                    onError(stringResourcePlain(Res.string.unexpected_error) + "${e.message}")
                }
            }
        }
    }
}